import { render, staticRenderFns } from "./IsNotLoginAndRegistered.vue?vue&type=template&id=656cb3ae"
import script from "./IsNotLoginAndRegistered.vue?vue&type=script&lang=js"
export * from "./IsNotLoginAndRegistered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme3ComponentsExchangeRate: require('/app/components/Theme3/Components/ExchangeRate.vue').default,Theme3DesktopLanguageSwitcher: require('/app/components/Theme3/Desktop/LanguageSwitcher.vue').default})
